import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';

export interface EventSearch {
  id: number;
  name: string;
  thumbnail: string;
  venue_name?: string;
  city?: string;
  start?: string;
}

@Injectable()
export class EventSearchService {
  constructor(private http: HttpClient) {}

  filterEvents = (
    filter: string,
    pastEvents: boolean = true,
    verified: boolean = true,
    onlyWithCampaign: boolean = false,
    endDateFrom: string | null = null,
    endDateTo: string | null = null,
  ) => {
    const params: Record<string, string> = {
      q: filter,
      past_events: pastEvents.toString(),
      is_verified: verified.toString(),
      only_events_with_campaign: onlyWithCampaign.toString(),
    };
    if (endDateFrom) params['end_date_from'] = endDateFrom;
    if (endDateTo) params['end_date_to'] = endDateTo;
    return this.http.get<Array<EventSearch>>(`/rest-api/v1/events/search?`, {params});
  };
}
